import React from 'react';
import {Switch, withRouter} from 'react-router-dom';
import PropsRoute from './utils/PropsRoute';
import EmployeeDetailsComponent from './EmployeeDetailComponent';
import EmployeeListComponent from './lists/EmployeeListComponent';

const EmployeeComponent = ({match, user, invoice}) => (
    <Switch>
        <PropsRoute exact path={`${match.url}/:staffId`} component={EmployeeDetailsComponent} user={user} invoice={invoice}/>
        <PropsRoute path={match.url} component={EmployeeListComponent} user={user} invoice={invoice}/>
    </Switch>
);

export default withRouter(EmployeeComponent);